import React from 'react';
import { applyRouterMiddleware, Router, Route, IndexRoute, Redirect, browserHistory } from 'react-router';
import useScroll from 'react-router-scroll';
import TopBar from '../TopBar/TopBar.jsx';
import Footer from '../Footer/Footer.jsx';
import HomeView from '../../views/HomeView/HomeView.jsx';
import AboutView from '../../views/AboutView/AboutView.jsx';
import CourseListView from '../../views/CourseListView/CourseListView.jsx';
import CourseView from '../../views/CourseView/CourseView.jsx';
import NewsListView from '../../views/NewsListView/NewsListView.jsx';
import NewsView from '../../views/NewsView/NewsView.jsx';
import ContactView from '../../views/ContactView/ContactView.jsx';
import TermsView from '../../views/TermsView/TermsView.jsx';
import PrivacyView from '../../views/PrivacyView/PrivacyView.jsx';
import VideoView from '../../views/VideoView/VideoView.jsx';

const AppLayout = (props) => {
  return (
    <div>
      <TopBar />
      {props.children}
      <Footer />
    </div>
  );
};

export default () => {
  return (
    <Router history={browserHistory} render={applyRouterMiddleware(useScroll())}>
      <Route component={AppLayout} path="/">
        <IndexRoute component={HomeView} />
        <Route component={AboutView} path="/about" />
        <Route component={CourseListView} path="/courses" />
        <Route component={CourseView} path="/course/:courseId" />
        <Route component={NewsListView} path="/news" />
        <Route component={NewsView} path="/newsdetails" />
        <Route component={VideoView} path="/video/:videoId" />
        {/*<Route component={ ContactView } path="/contact" />*/}
        <Route component={TermsView} path="/terms" />
        <Route component={PrivacyView} path="/privacy" />
        <Redirect from='*' to="/" />
      </Route>
    </Router>
  );
};




/** WEBPACK FOOTER **
 ** ./src/js/app/App/App.jsx
 **/